export default __webpack_public_path__ + "assets/fe2c4bd6645c93a2bd0a3c3a72f8ade8.jpg";